import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  signal,
  ViewChild,
  input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { SwiperOptions } from 'swiper';
import { ArgoVideoShort } from '../../interfaces';
import { CarouselComponent } from '../carousel/carousel.component';
import { PlaylistItemComponent } from '../playlist-item/playlist-item.component';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { TextTruncateDirective } from '../../directives/text-truncate.directive';
import { IconComponent } from '@outlaw/icons';

@Component({
  selector: 'outlaw-playlist-carousel',
  imports: [CommonModule, CarouselComponent, PlaylistItemComponent, TextTruncateDirective, IconComponent],
  templateUrl: './playlist-carousel.component.html',
  styleUrls: ['./playlist-carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('accordionAnimation', [
      state(
        'closed',
        style({
          height: '0',
          overflow: 'hidden',
          opacity: 0,
          padding: '0 16px',
        })
      ),
      state(
        'open',
        style({
          height: '*',
          opacity: 1,
        })
      ),
      transition('closed <=> open', [animate('0.3s ease-in-out')]),
    ]),
  ],
})
export class PlaylistCarouselComponent {
  @Input() videos: ArgoVideoShort[] = [];
  @Input() selectedVideo: ArgoVideoShort | null = null;
  @Input() carouselConfig: SwiperOptions = {
    navigation: false,
    spaceBetween: 12,
  };
  canDisplayTrailerButton = input<boolean>(false);
  @Output() videoClick = new EventEmitter<ArgoVideoShort>();
  @Output() trailerClick = new EventEmitter<void>();

  @ViewChild('description') description!: TextTruncateDirective;

  isOpen = signal(true);

  toggleAccordion(): void {
    this.isOpen.update(value => !value);
  }

  onVideoClick(video: ArgoVideoShort): void {
    if (this.selectedVideo?.id !== video.id) {
      this.description.reset();
    }
    this.videoClick.emit(video);
  }

  onTrailerClick() {
    this.trailerClick.emit();
  }
}
